import { Type } from 'class-transformer';
import { IFormType } from '../interfaces/form-type.interface';

export class FormTypeDto implements IFormType {
  id!: string;

  uniqueCode!: string;

  name!: string;

  description!: string;

  url!: string;

  @Type(() => Date)
  creationDate!: Date;
}
